export enum EnumTipoAvaliacaoDesempenho {
    NaoAvalia = 0,
    Avalia = 1,
}